import { sum } from 'utils/calculator';
import { ANY_BELGIAN_STATION_SHORT_TARIFF_CODE } from 'constants/booking';

export const buildProductsByItemRefs = ({ products = [], bookingItemRefs = [] }) =>
  products.filter(({ itemRef }) => bookingItemRefs.includes(itemRef));
export const getAssociatedRefsForBookingItemRef = ({ products = [], bookingItemRefs = [] }) =>
  buildProductsByItemRefs({ products, bookingItemRefs })
    ?.map(({ associatedItemRefs }) => associatedItemRefs)
    ?.flat();
export const buildABSProducts = ({ products = [], extraProducts = [], bookingItemRefs = [] }) =>
  buildProductsByItemRefs({
    products: extraProducts,
    bookingItemRefs: getAssociatedRefsForBookingItemRef({ products, bookingItemRefs })
  })?.filter(({ tariffDetails }) => tariffDetails.tariffCode?.slice(0, 3) === ANY_BELGIAN_STATION_SHORT_TARIFF_CODE);
export const buildPassengers = ({ products = [], bookingItemRefs = [] }) =>
  products
    .filter(({ itemRef }) => bookingItemRefs.includes(itemRef))
    ?.map(({ passenger, tariffDetails }) => ({
      id: passenger.id,
      type: passenger.type,
      disabilityType: passenger.disabilityType,
      tariffDetails
    }));

export const passengerSummary = ({ passengers = [] }) =>
  passengers.reduce((acc, { tariffDetails, type, disabilityType }) => {
    const id = `${tariffDetails?.tariffCode}-${type}-${tariffDetails?.bucketCode}`;
    const pax = acc[id];

    return {
      ...acc,
      [id]: {
        disabilityType,
        type,
        count: sum([pax?.count, 1]) ?? 1,
        bucketCode: tariffDetails?.bucketCode
      }
    };
  }, {});

export const buildExchangeSummarySegments = ({ segment = [], bookingItemRefs = [] }) =>
  segment.map(({ trainNumber, classOfService, serviceType, timing, origin, destination, extraProducts, serviceIdentifier, products }) => ({
    timing,
    origin,
    destination,
    absProducts: buildABSProducts({ products, extraProducts, bookingItemRefs }),
    trainNumber,
    serviceIdentifier,
    classOfService,
    serviceType,
    passengers: buildPassengers({ products, bookingItemRefs }),
    products: buildProductsByItemRefs({ products, bookingItemRefs })
  }));
